<style scoped  lang="less">
@import "detailsMatchSummary.less"; // 引入公共LESS文件
</style>
<template>
  <div>
    <div class="data-loading" style="padding: 20vh 0 50vh 0" v-if="isloginShow">
      <van-loading vertical
        ><span class="loadtext">{{ langConfig.txtLang[langConfig.curLang]['LOADING'] }}</span></van-loading
      >
    </div>
    <div class="detailsMatchSummary" v-if="match != null && matchId != null">
      <!-- {{matchId}} -->
      <!-- 进攻 -->
      <div class="offensive">
        <!-- 直框图 -->
        <div class="barIframeBox" v-if="match.hasEventLive">
          <iframe
            :src="'/static/odChart/index.html?lan=3&&id=' + matchId"
            frameborder="0"
            width="100%"
            height="100%"
            ref="myIframe"
          ></iframe>
        </div>
        <!-- <a href="javascript:void(0);" @click="aaa1">调试按钮，测试忽略别报BUG</a> -->
        <!-- <a href="javascript:void(0);" @click="aaa1">调试按钮，测试忽略别报BUG</a> &&[1,2,3,17].indexOf(match.state*1)>-1-->
        <!-- 表格 &&[1,2,3,17].indexOf(match.state*1)>-1 -->
        <div
          class="chanceBox"
          :class="pickerTab == 2 ? 'chanceBox_on' : ''"
          v-if="chanceStats && [1, 2, 3, 17].indexOf(match.state * 1) > -1"
        >
          <div class="chanceTab">
            <div class="cTab_li">
              <a
                href="javascript:void(0);"
                :class="pickerTab == 1 ? 'on' : ''"
                @click="tabShow(1)"
                >{{ langConfig.details[langConfig.curLang]["SUMMARY"]["GOALS"] }}</a
              >
            </div>
            <div class="cTab_li">
              <a
                href="javascript:void(0);"
                :class="pickerTab == 2 ? 'on' : ''"
                @click="tabShow(2)"
                >{{ langConfig.details[langConfig.curLang]["SUMMARY"]["CARDS"] }}</a
              >
            </div>
          </div>
          <div class="chance chance1">
            <!-- 顶部 -->
            <div class="chanceTop">
              <!-- 标题 -->
              <div class="title">
                {{ pickerVal.goal.title[pickerVal.goal.Be0] }}
              </div>
              <div class="pickerUl">
                <div class="checkbox">
                  <el-checkbox-group
                    v-model="pickerVal.goal.checkbox"
                    @change="handCheckChange('goal')"
                  >
                    <el-checkbox :label='langConfig.details[langConfig.curLang]["SUMMARY"]["HOME_AWAY"]' size="medium"></el-checkbox>
                  </el-checkbox-group>
                </div>
                <!-- 下拉 -->
                <div class="picker">
                  <DasePicker
                    class="dasePickerBox"
                    ref="dasePicker_goal"
                    :options="pickerList"
                    @changePicker="
                      (v) => {
                        changePicker(v, 'goal');
                      }
                    "
                  ></DasePicker>
                </div>
              </div>
            </div>
            <!-- 时间 -->
            <div class="chanceTime" v-if="pickerVal.goal.Be0 == 'first'">
              <p>
                <span>0'</span>
                <span>15'</span>
                <span>30'</span>
                <span>45'</span>
                <span>60'</span>
                <span>75'</span>
                <span>90'</span>
              </p>
            </div>
            <div
              class="chanceTeam"
              :class="pickerVal.goal.Be0 == 'again' ? 'chanceTeam_t' : ''"
            >
              <div class="teamLi">
                <div class="teamData">
                  <img
                    :src="common.teamImgGet(match['homeTeam']['id'])"
                    @error="common.imgError($event, 'team')"
                    a
                    alt=""
                  />
                  <span>{{ match["homeTeam"]["fullName"] }}</span>
                </div>
                <div class="teamNum" v-if="pickerVal.goal.Be0 == 'first'">
                  <span
                    v-for="(item, index) in chanceStats['goal']['first'][
                      pickerVal.goal.pickerVal + pickerVal.goal.checkVal
                    ].homeTeamValues"
                    :key="index"
                    :class="
                      findMaxIndex(
                        chanceStats['goal']['first'][
                          pickerVal.goal.pickerVal + pickerVal.goal.checkVal
                        ].homeTeamValues
                      ).indexOf(index) != -1
                        ? 'on'
                        : ''
                    "
                    >{{ item }}</span
                  >
                  <!-- <span>0%</span>
                  <span>0%</span>
                  <span class="on">0%</span>
                  <span>0%</span>
                  <span>0%</span> -->
                </div>
                <div class="teamNum" v-if="pickerVal.goal.Be0 == 'again'">
                  <p>
                    <i
                      :style="
                        'width:' +
                        chanceStats['goal']['again'][
                          pickerVal.goal.pickerVal + pickerVal.goal.checkVal
                        ].homeTeamValues[
                          pickerVal['goal'].homeVal >
                          chanceStats['goal']['again'][
                            pickerVal.goal.pickerVal + pickerVal.goal.checkVal
                          ].homeTeamValues.length *
                            1 -
                            1
                            ? chanceStats['goal']['again'][
                                pickerVal.goal.pickerVal +
                                  pickerVal.goal.checkVal
                              ].homeTeamValues.length *
                                1 -
                              1
                            : pickerVal['goal'].homeVal
                        ]
                      "
                    ></i>

                    <b>{{
                      chanceStats["goal"]["again"][
                        pickerVal.goal.pickerVal + pickerVal.goal.checkVal
                      ].homeTeamValues[
                        pickerVal["goal"].homeVal >
                        chanceStats["goal"]["again"][
                          pickerVal.goal.pickerVal + pickerVal.goal.checkVal
                        ].homeTeamValues.length *
                          1 -
                          1
                          ? chanceStats["goal"]["again"][
                              pickerVal.goal.pickerVal + pickerVal.goal.checkVal
                            ].homeTeamValues.length *
                              1 -
                            1
                          : pickerVal["goal"].homeVal
                      ]
                    }}</b>
                  </p>
                </div>
              </div>
              <div class="teamLi">
                <div class="teamData">
                  <img
                    :src="common.teamImgGet(match['awayTeam']['id'])"
                    @error="common.imgError($event, 'team')"
                    alt=""
                  />
                  <span>{{ match["awayTeam"]["fullName"] }}</span>
                </div>
                <div class="teamNum" v-if="pickerVal.goal.Be0 == 'first'">
                  <span
                    v-for="(item, index) in chanceStats['goal']['first'][
                      pickerVal.goal.pickerVal + pickerVal.goal.checkVal
                    ].awayTeamValues"
                    :key="index"
                    :class="
                      findMaxIndex(
                        chanceStats['goal']['first'][
                          pickerVal.goal.pickerVal + pickerVal.goal.checkVal
                        ].awayTeamValues
                      ).indexOf(index) != -1
                        ? 'on'
                        : ''
                    "
                    >{{ item }}</span
                  >
                  <!-- :class="findMaxIndex(chanceStats['goal']['first'][pickerVal.goal.pickerVal+pickerVal.goal.checkVal].awayTeamValues)==index?'on':''" -->
                  <!-- <span class="on">0%</span>
                  <span>0%</span>
                  <span>0%</span>
                  <span>0%</span>
                  <span>0%</span> -->
                </div>
                <div class="teamNum" v-if="pickerVal.goal.Be0 == 'again'">
                  <p>
                    <i
                      :style="
                        'width:' +
                        chanceStats['goal']['again'][
                          pickerVal.goal.pickerVal + pickerVal.goal.checkVal
                        ].awayTeamValues[
                          pickerVal['goal'].awayVal >
                          chanceStats['goal']['again'][
                            pickerVal.goal.pickerVal + pickerVal.goal.checkVal
                          ].awayTeamValues.length *
                            1 -
                            1
                            ? chanceStats['goal']['again'][
                                pickerVal.goal.pickerVal +
                                  pickerVal.goal.checkVal
                              ].awayTeamValues.length *
                                1 -
                              1
                            : pickerVal['goal'].awayVal
                        ]
                      "
                    ></i>
                    <b>{{
                      chanceStats["goal"]["again"][
                        pickerVal.goal.pickerVal + pickerVal.goal.checkVal
                      ].awayTeamValues[
                        pickerVal["goal"].awayVal >
                        chanceStats["goal"]["again"][
                          pickerVal.goal.pickerVal + pickerVal.goal.checkVal
                        ].awayTeamValues.length *
                          1 -
                          1
                          ? chanceStats["goal"]["again"][
                              pickerVal.goal.pickerVal + pickerVal.goal.checkVal
                            ].awayTeamValues.length *
                              1 -
                            1
                          : pickerVal["goal"].awayVal
                      ]
                    }}</b>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="chance chance2">
            <!-- 顶部 -->
            <div class="chanceTop">
              <!-- 标题 -->
              <div class="title">
                {{ pickerVal.card.title[pickerVal.card.Be0] }}
              </div>
              <div class="pickerUl">
                <!-- 下拉 -->
                <div class="checkbox">
                  <el-checkbox-group
                    v-model="pickerVal.card.checkbox"
                    @change="handCheckChange('card')"
                  >
                    <el-checkbox :label='langConfig.details[langConfig.curLang]["SUMMARY"]["HOME_AWAY"]' size="medium"></el-checkbox>
                  </el-checkbox-group>
                </div>
                <!-- 下拉 -->
                <div class="picker">
                  <DasePicker
                    class="dasePickerBox"
                    ref="dasePicker_card"
                    :options="pickerList"
                    @changePicker="
                      (v) => {
                        changePicker(v, 'card');
                      }
                    "
                  ></DasePicker>
                </div>
              </div>
            </div>
            <!-- 时间 -->
            <div class="chanceTime" v-if="pickerVal.card.Be0 == 'first'">
              <p>
                <span>0'</span>
                <span>15'</span>
                <span>30'</span>
                <span>45'</span>
                <span>60'</span>
                <span>75'</span>
                <span>90'</span>
              </p>
            </div>
            <div
              class="chanceTeam"
              :class="pickerVal.card.Be0 == 'again' ? 'chanceTeam_t' : ''"
            >
              <div class="teamLi">
                <div class="teamData">
                  <img
                    :src="common.teamImgGet(match['homeTeam']['id'])"
                    @error="common.imgError($event, 'team')"
                    alt=""
                  />
                  <span>{{ match["homeTeam"]["fullName"] }}</span>
                </div>
                <div class="teamNum" v-if="pickerVal.card.Be0 == 'first'">
                  <span
                    v-for="(item, index) in chanceStats['card']['first'][
                      pickerVal.card.pickerVal + pickerVal.card.checkVal
                    ].homeTeamValues"
                    :key="index"
                    :class="
                      findMaxIndex(
                        chanceStats['card']['first'][
                          pickerVal.card.pickerVal + pickerVal.card.checkVal
                        ].homeTeamValues
                      ).indexOf(index) != -1
                        ? 'on'
                        : ''
                    "
                    >{{ item }}</span
                  >
                </div>
                <div class="teamNum" v-if="pickerVal.card.Be0 == 'again'">
                  <p>
                    <i
                      :style="
                        'width:' +
                        chanceStats['card']['again'][
                          pickerVal.card.pickerVal + pickerVal.card.checkVal
                        ].homeTeamValues[
                          pickerVal['card'].homeVal >
                          chanceStats['card']['again'][
                            pickerVal.card.pickerVal + pickerVal.card.checkVal
                          ].homeTeamValues.length *
                            1 -
                            1
                            ? chanceStats['card']['again'][
                                pickerVal.card.pickerVal +
                                  pickerVal.card.checkVal
                              ].homeTeamValues.length *
                                1 -
                              1
                            : pickerVal['card'].homeVal
                        ]
                      "
                    ></i>
                    <b>{{
                      chanceStats["card"]["again"][
                        pickerVal.card.pickerVal + pickerVal.card.checkVal
                      ].homeTeamValues[
                        pickerVal["card"].homeVal >
                        chanceStats["card"]["again"][
                          pickerVal.card.pickerVal + pickerVal.card.checkVal
                        ].homeTeamValues.length *
                          1 -
                          1
                          ? chanceStats["card"]["again"][
                              pickerVal.card.pickerVal + pickerVal.card.checkVal
                            ].homeTeamValues.length *
                              1 -
                            1
                          : pickerVal["card"].homeVal
                      ]
                    }}</b>
                  </p>
                </div>
              </div>
              <div class="teamLi">
                <div class="teamData">
                  <img
                    :src="common.teamImgGet(match['awayTeam']['id'])"
                    @error="common.imgError($event, 'team')"
                    alt=""
                  />
                  <span>{{ match["awayTeam"]["fullName"] }}</span>
                </div>

                <div class="teamNum" v-if="pickerVal.card.Be0 == 'first'">
                  <span
                    v-for="(item, index) in chanceStats['card']['first'][
                      pickerVal.card.pickerVal + pickerVal.card.checkVal
                    ].awayTeamValues"
                    :key="index"
                    :class="
                      findMaxIndex(
                        chanceStats['card']['first'][
                          pickerVal.card.pickerVal + pickerVal.card.checkVal
                        ].awayTeamValues
                      ).indexOf(index) != -1
                        ? 'on'
                        : ''
                    "
                    >{{ item }}</span
                  >
                </div>
                <div class="teamNum" v-if="pickerVal.card.Be0 == 'again'">
                  <p>
                    <i
                      :style="
                        'width:' +
                        chanceStats['card']['again'][
                          pickerVal.card.pickerVal + pickerVal.card.checkVal
                        ].awayTeamValues[
                          pickerVal['card'].awayVal >
                          chanceStats['card']['again'][
                            pickerVal.card.pickerVal + pickerVal.card.checkVal
                          ].awayTeamValues.length *
                            1 -
                            1
                            ? chanceStats['card']['again'][
                                pickerVal.card.pickerVal +
                                  pickerVal.card.checkVal
                              ].awayTeamValues.length *
                                1 -
                              1
                            : pickerVal['card'].awayVal
                        ]
                      "
                    ></i>
                    <b>{{
                      chanceStats["card"]["again"][
                        pickerVal.card.pickerVal + pickerVal.card.checkVal
                      ].awayTeamValues[
                        pickerVal["card"].awayVal >
                        chanceStats["card"]["again"][
                          pickerVal.card.pickerVal + pickerVal.card.checkVal
                        ].awayTeamValues.length *
                          1 -
                          1
                          ? chanceStats["card"]["again"][
                              pickerVal.card.pickerVal + pickerVal.card.checkVal
                            ].awayTeamValues.length *
                              1 -
                            1
                          : pickerVal["card"].awayVal
                      ]
                    }}</b>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 上下半场事件 -->
      <div class="incident" v-if="keyList">
        <div class="list event-box">
          <ul>
            <template v-for="(item, index) in keyList">
              <li
                class="li_title"
                :key="index + 't'"
                v-if="ketTitleShow(keyList, index) == '1st'"
              >
                <p class="title">
                  {{
                    langConfig.details[langConfig.curLang]["SUMMARY"][
                      "1ST_HALF"
                    ]
                  }}
                  <span v-if="isScore('scoreHalf')"
                    >{{
                      match.homeLive["scoreHalf"]
                        ? match.homeLive["scoreHalf"]
                        : 0
                    }}-{{
                      match.awayLive["scoreHalf"]
                        ? match.awayLive["scoreHalf"]
                        : 0
                    }}</span
                  >
                </p>
              </li>

              <li
                class="li_title"
                :key="index + 'y'"
                v-if="ketTitleShow(keyList, index) == '2st'"
              >
                <p class="title">
                  {{
                    langConfig.details[langConfig.curLang]["SUMMARY"][
                      "2ST_HALF"
                    ]
                  }}
                  <span v-if="isScore('scoreFull')"
                    >{{
                      match.homeLive["scoreFull"]
                        ? match.homeLive["scoreFull"]
                        : 0
                    }}-{{
                      match.awayLive["scoreFull"]
                        ? match.awayLive["scoreFull"]
                        : 0
                    }}</span
                  >
                </p>
              </li>

              <li
                class="li_title"
                :key="index + 'o'"
                v-if="ketTitleShow(keyList, index) == 'add'"
              >
                <p class="title">
                  {{
                    langConfig.details[langConfig.curLang]["SUMMARY"][
                      "EXTRA_TIME"
                    ]
                  }}
                  <span v-if="isScore('scoreOt')"
                    >{{
                      match.homeLive["scoreOt"] ? match.homeLive["scoreOt"] : 0
                    }}-{{
                      match.awayLive["scoreOt"] ? match.awayLive["scoreOt"] : 0
                    }}</span
                  >
                </p>
              </li>
              <li
                class="li_title"
                :key="index + 'r'"
                v-if="ketTitleShow(keyList, index) == 'iskick'"
              >
                <p class="title">
                  {{
                    langConfig.details[langConfig.curLang]["SUMMARY"][
                      "PENALTY_SHOOTOUT"
                    ]
                  }}
                  <span v-if="isScore('scorePen')"
                    >{{
                      match.homeLive["scorePen"]
                        ? match.homeLive["scorePen"]
                        : 0
                    }}-{{
                      match.awayLive["scorePen"]
                        ? match.awayLive["scorePen"]
                        : 0
                    }}</span
                  >
                </p>
              </li>

              <li
                :key="index"
                v-if="
                  [1, 2, 3, 4, 5, 6, 7, 9, 10].indexOf(item.eventType * 1) > -1
                "
                :class="
                  (item.teamNum == 1 ? ' li_l' : '') +
                  (item.teamNum == 2 ? ' li_r' : '')
                "
              >
                <template>
                  <!-- findKetIndex(arr, targetIndex) -->
                  <template>
                    <i v-if="[9, 10].indexOf(item.eventType * 1) > -1">{{
                      findKetIndex(keyList, item.id) * 1 + 1
                    }}</i>
                    <i v-else
                      >{{ item.happenTime
                      }}{{
                        item.extraTime ? "" + "+" + "" + item.extraTime : ""
                      }}’</i
                    >
                  </template>
                  <p>
                    <template
                      v-if="
                        [1, 2, 3, 4, 5, 6, 9, 10].indexOf(item.eventType * 1) >
                        -1
                      "
                    >
                      <span>
                        <img
                          :src="
                            require(`@/assets/images/details/match_summary/${item.eventType}.svg`)
                          "
                        />
                        {{
                          item.eventPlayer.name ? item.eventPlayer.name : ""
                        }}
                        {{ eventTetx[item.eventType]
                        }}{{ item.score ? "(" + item.score + ")" : "" }}</span
                      >
                    </template>
                    <template v-if="item.eventType == 7">
                      <span>
                        <img
                          src="~@/assets/images/details/match_summary/up.svg"
                        />
                        {{ item.eventPlayer.name }}
                      </span>
                      <span>
                        <!-- 换下 -->
                        <img
                          src="~@/assets/images/details/match_summary/down.svg"
                        />{{ eventTetx["-1"] }} {{ item.changePlayer.name }}
                      </span>
                    </template>
                  </p>
                </template>
              </li>
              <!-- <li class="li_title" :key="index+'k'"  v-if="item.eventType==8">
                <p class="title">{{langConfig.details[langConfig.curLang]['KEYLIST']['critical_event']}}点球大战开始</p>
              </li> -->
              <!-- <li class="li_title" :key="index+'p'"  v-if="index==(keyList.length*1-1)">
                <p class="title">  1ST Half-- <span>0-0</span></p>
              </li> -->
            </template>
            <li class="li_title">
              <div
                class="incident incident_2"
                v-if="courtInfoList && courtInfoList.length > 0"
              >
                <div class="list">
                  <p class="title">
                    {{
                      langConfig.details[langConfig.curLang]["SUMMARY"][
                        "MATCH_INFO"
                      ]
                    }}
                  </p>
                  <div class="infoList">
                    <p v-for="(value, key) in courtInfoList" :key="key">
                      {{ value.title }}:{{ value.content }}
                    </p>
                    <!-- <p>Weather: Light thunderstorm 27°/81℉</p>
            <p>Stadium: Old Trafford</p>
            <p>Spectators: 51,000</p>
            <p>Local Time: 17/08 20:30</p>
            <p>Referee: Rogres</p> -->
                  </div>
                </div>
              </div>
            </li>
            <!-- <li class="li_title">
                <p class="title">1ST Half <span>2-1</span></p>
              </li>
              <li class="li_r">
                <i>14’</i>
                <p>
                  <span>
                    <img src="~@/assets/images/details/incident_7.svg" />XXXXXXXXXXXXXXXXXX
                  </span>
                </p>
              </li> -->
          </ul>
        </div>

        <!-- <div class="list">
          <p class="title">1ST Half <span>2-1</span></p>
          <ul>
            <li class="li_l">
              <i>14’</i>
              <p>
                <span>
                  <img src="~@/assets/images/details/incident_7.svg" />XXXXXXXXXXXXXXXXXX
                </span>
                <span>
                  <img src="~@/assets/images/details/incident_7.svg" />XXXXXXXXXXXXXXXXXX
                </span>
              </p>
            </li>
            <li class="li_r">
              <i>14’</i>
              <p>
                <span>
                  <img src="~@/assets/images/details/incident_7.svg" />XXXXXXXXXXXXXXXXXX
                </span>
              </p>
            </li>
          </ul>
        </div> -->
      </div>

      <div
        class="no-data"
        v-if="
          !match.hasEventLive &&
          !(chanceStats && [1, 2, 3, 17].indexOf(match.state * 1) > -1) &&
          !keyList &&
          !(courtInfoList && courtInfoList.length > 0) &&
          !isloginShow
        "
      >
        <img :src="require(`@/assets/images/icon-nodata.png`)" alt="" />
        <span>{{ langConfig.txtLang[langConfig.curLang]["NO_DATA"] }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import DasePicker from "@/components/basePicker.vue";
import { getMatchSummary } from "@/api/api";

//const detailsText =this.langConfig.details[this.langConfig.curLang];

export default {
  components: {
    DasePicker,
  },
  data() {
    return {
      isReadTime: 0,
      isloginShow: true,
      checkList: [],
      baseParam: {
        userToken: "",
      },
      // pickerList:[{value:'currentSeason',name:'本赛季'},{value:'recentTen',name:'近10场'},{value:'recentTwenty',name:'近20场'}],
      pickerList:
        this.langConfig.details[this.langConfig.curLang]["PICKERLIST"],
      pickerVal: {
        card: {
          checkbox: [],
          checkVal: "",
          pickerIndex: 1,
          pickerVal: "recentTen",
          // goal:{},
          // first:{},
          title: {
            again:
              this.langConfig.details[this.langConfig.curLang]["PROBABILITY"][
                "card_again"
              ], //再获得罚牌概率
            first:
              this.langConfig.details[this.langConfig.curLang]["PROBABILITY"][
                "card_first"
              ], //'首罚概率分布'
            // again:'再获得罚牌概率',//再获得罚牌概率
            // first:'首罚概率分布',//'首罚概率分布'
          },
          homeVal: 0,
          awayVal: 0,
          Be0: "again", //first again
        },
        goal: {
          checkbox: [],
          checkVal: "",
          pickerIndex: 1,
          pickerVal: "recentTen",
          // goal:{},
          // first:{},
          title: {
            again:
              this.langConfig.details[this.langConfig.curLang]["PROBABILITY"][
                "goal_again"
              ], //'再进球概率',
            first:
              this.langConfig.details[this.langConfig.curLang]["PROBABILITY"][
                "goal_first"
              ], //首入球概率分布
            // again:'再进球概率',//'再进球概率',
            // first:'首入球概率分布',//首入球概率分布
          },
          homeVal: 0,
          awayVal: 0,
          Be0: "again", //first again
        },
      },
      pickerTab: 1,
      chanceStats: null,
      courtInfoList: null,
      keyList: null,
      //eventTetx:{1:'进球',2:'点球',3:'乌龙球',4:'黄牌',5:'两黄变一红',6:'红牌',7:'替换球员',8:'点球大战开始',9:'点球射进',10:'点球射失','-1':'Substituted'},
      eventTetx:
        this.langConfig.details[this.langConfig.curLang]["EVENT_SUMMARY"],
    };
  },

  watch: {
    isRead(val) {
      if (val != this.isReadTime) {
        this.init();
        this.isReadTime = val;

        console.log("MatchSummary-数据重置");
      }
    },
    matchId() {
      //this.init();
      //console.log('matchId','11111');
    },
    match() {
      this.pickerScoreInit();
    },
    socketKeyList(val) {
      var list = val || [];
      // let keyList=JSON.parse(JSON.stringify(this.keyList))||[];
      // this.keyList=mergeArrays(list, keyList);
      //console.log('111',val);
      if (list.length > 0) {
        this.keyList = val;
      }
    },
  },
  methods: {
    // loading
    logdingFlag() {
      if (typeof window != "undefined" && this.isloginShow) {
        return true;
      }
      return false;
    },
    ketTitleShow(list, index) {
      var st1_index = list.findIndex((item) => item.happenTime <= 45);
      var st2_index = list.findIndex(
        (item) => item.happenTime > 45 && item.happenTime <= 90
      );
      var add_index = list.findIndex(
        (item) =>
          item.happenTime > 90 &&
          item.eventType != 8 &&
          item.eventType != 9 &&
          item.eventType != 10
      );
      var iskick = list.findIndex(
        (item) =>
          item.eventType == 8 || item.eventType == 9 || item.eventType == 10
      );
      if (index == st1_index) {
        return "1st";
      } else if (index == st2_index) {
        return "2st";
      } else if (index == add_index) {
        return "add";
      } else if (index == iskick) {
        return "iskick";
      }
    },

    findKetIndex(arr, _id) {
      // function findObjectsByIndex(arr, targetIndex) {
      //     // 找到所有 time 等于 55 或 48 的元素的索引
      //     var indices = arr.reduceRight((acc, item, index) => {
      //       if (index === targetIndex && (item.time === 55 || item.time === 48)) {
      //         acc.push({ object: item, occurrence: acc.length + 1 });
      //       }
      //       return acc;
      //     }, []);

      //     return indices;
      // }
      //console.log('acc',acc);
      //console.log('item',item);
      //console.log('index',index);
      var all = [];
      arr.reduceRight((acc, item, index) => {
        //console.log('acc',acc);
        //console.log('item',item);
        //console.log('index',index);
        if (item.eventType === 10 || item.eventType === 9) {
          all.push(item);
        }
      }, []);
      //console.log('all',all);
      return all.findIndex((item) => item.id == _id);
      //console.log(targetIndex,all);
      // return indices;

      var a = [
        { time: 60 },
        { time: 55 },
        { time: 55 },
        { time: 55 },
        { time: 55 },
        { time: 48 },
        { time: 33 },
        { time: 33 },
        { time: 34 },
        { time: 35 },
      ];
      //用函数写个，输入index加入等于4，计算出这个index=4的对象，里面的time，在这个数组里面符合 time<=55&&time>33的范围内的累计次数的

      // var targetIndex = 5; // 传入你想要检查的索引

      // var result = findObjectsByIndex(a, targetIndex);
      //console.log(result);
    },

    aaa1() {
      //console.log('this.pickerVal',this.pickerVal);
      //console.log('chanceStats',this.chanceStats);
      var chanceStats = this.chanceStats;
      var pickerVal = this.pickerVal;
      //console.log('aaaaaa',chanceStats['card']['again']);
      //console.log('aaaaaa',chanceStats['card']['again'][pickerVal.card.pickerVal+pickerVal.card.checkVal].awayTeamValues[pickerVal['card'].awayVal]);
    },
    //判断是否为半场
    isScoreHalf() {
      let match = JSON.parse(JSON.stringify(this.match)) || {};
      return (
        match.homeLive["scoreHalf"] != undefined ||
        match.awayLive["scoreHalf"] != undefined
      );
    },
    //判断是否有比分
    isScore(name) {
      //scoreHalf
      let match = JSON.parse(JSON.stringify(this.match)) || {};
      return (
        match.homeLive[name] != undefined || match.awayLive[name] != undefined
      );
    },
    //合并数组并去重
    mergeArrays(a, b) {
      // 合并两个数组
      const merged = [...b, ...a];
      const uniqueMap = new Map();
      for (const item of merged) {
        uniqueMap.set(item.id, item);
      }
      const result = Array.from(uniqueMap.values());
      return result;
    },
    tabShow(val) {
      this.pickerTab = val;
    },
    //数组返回最大
    findMaxIndex(data) {
      if (data.length === 0) {
        return [-1]; // 数组为空时返回 -1 或者适当的默认值
      }
      data = data.map((str) => (parseFloat(str) > 0 ? parseFloat(str) : 0));
      data = JSON.parse(JSON.stringify(data));
      function findMaxIndexes(arr) {
        if (!Array.isArray(arr) || arr.length === 0) {
          console.error("Invalid input");
          return [];
        }

        // 找到最大值
        const maxNumber = Math.max(...arr);
        // 找到所有最大值的索引
        const maxIndexes = arr.reduce((acc, num, index) => {
          if (num === maxNumber && num != 0) {
            acc.push(index);
          }
          return acc;
        }, []);
        return maxIndexes;
      }

      // 示例
      const array = data;
      const maxIndexes = findMaxIndexes(array);
      //console.log('maxIndexes221',maxIndexes);
      return maxIndexes;
    },
    //概率-初始化
    pickerInit() {
      if (this.$refs.dasePicker_goal) {
        this.$refs.dasePicker_goal.setValue(1);
      }
      if (this.$refs.dasePicker_card) {
        this.$refs.dasePicker_card.setValue(1);
      }

      let pickerVal = { ...this.pickerVal };
      let pickerList = [...this.pickerList];
      // 赋值
      pickerVal.card = {
        ...pickerVal.card,
        pickerIndex: 1,
        pickerVal: pickerList[1].value,
      };
      pickerVal.goal = {
        ...pickerVal.goal,
        pickerIndex: 1,
        pickerVal: pickerList[1].value,
      };
      this.pickerVal = pickerVal;
    },
    //概率-同主客选择
    handCheckChange(type) {
      let pickerVal = { ...this.pickerVal };
      // 赋值
      let isCheck = pickerVal[type].checkbox.length > 0;
      pickerVal[type] = {
        ...pickerVal[type],
        checkVal: isCheck ? "SameSide" : "",
      };
      this.pickerVal = pickerVal;
      ////console.log('42244',detailsText);
    },
    //概率-下拉发生改变时
    changePicker(val, type) {
      let pickerVal = JSON.parse(JSON.stringify(this.pickerVal));
      pickerVal[type].pickerIndex = val.index;
      pickerVal[type].pickerVal = val.value;
      this.pickerVal = pickerVal;
    },
    //显示赋值
    pickerScoreInit() {
      let match = JSON.parse(JSON.stringify(this.match));
      if (!match) {
        return;
      }
      let pickerVal = JSON.parse(JSON.stringify(this.pickerVal));
      var score_h = 0;
      var score_a = 0;
      var card_h = 0;
      var card_a = 0;
      if (typeof match.homeLive != "undefined") {
        score_h = match.homeLive["scoreFull"] || 0;
        card_h =
          (match.homeLive["yellowCard"] || 0) * 1 +
          (match.homeLive["redCard"] || 0) * 2;
      }
      if (typeof match.awayLive != "undefined") {
        score_a = match.awayLive["scoreFull"] || 0;
        card_a =
          (match.awayLive["yellowCard"] || 0) * 1 +
          (match.awayLive["redCard"] || 0) * 2;
      }
      // score_h=(score_h>8?8:score_h);
      // score_a=(score_a>8?8:score_a);
      // card_h=(card_h>7?7:card_h);
      // card_a=(card_a>7?7:card_a);
      pickerVal.card.homeVal = card_h;
      pickerVal.card.awayVal = card_a;
      pickerVal.goal.homeVal = score_h;
      pickerVal.goal.awayVal = score_a;
      if (score_h == 0 && score_a == 0) {
        pickerVal.goal.Be0 = "first";
      } else {
        pickerVal.goal.Be0 = "again";
      }
      if (card_a == 0 && card_h == 0) {
        pickerVal.card.Be0 = "first";
      } else {
        pickerVal.card.Be0 = "again";
      }
      this.pickerVal = pickerVal;
    },
    //数据读取
    async getMatchInfoData() {
      let obj = {
        matchId: this.matchId,
      };
      var _this = this;
      let param = Object.assign(obj, this.baseParam);
      //console.log('param',param);
      await getMatchSummary(param)
        .then((res) => {
          this.isloginShow = false;
          //console.log('getMatchSummaryresresresa',res)
          let res1 = JSON.parse(JSON.stringify(res));
          let data = JSON.parse(JSON.stringify(res.data));
          //let data=res.data;
          //console.log('getMatchSummary_res',res1)
          //console.log('getMatchSummary_data',data)
          //有事件
          if (data.chanceStats) {
            _this.chanceStats = data.chanceStats;
            setTimeout(() => {
              _this.pickerInit();
            }, 10);
            //console.log('this.chanceStats1',this.chanceStats)
          }
          this.courtInfoList = data.courtInfoList || [];
          this.keyList = data.keyList || null;
          this.pickerScoreInit();
          //first 0-0
          //again 1-2
          //有SameSide就是同主课
          //类型：本赛季  最近10 最近20      card-罚牌 黄+红等于0显示首发牌first    大于0就显示again
          //左边看比分  右边看黄红牌
        })
        .catch((res) => {
          console.error(res);
        });
    },
    init() {
      if (!this.matchId) {
        return;
      }
      this.getMatchInfoData();
    },
  },
  created() {
    this.isReadTime = this.isRead;
    this.init();
  },
  mounted() {},
  beforeDestroy() {},
  props: {
    match: {
      type: Object,
      default: null,
    },
    socketKeyList: {
      type: Array,
      default: () => [],
    },
    matchId: {
      type: Number,
      default: null,
    },
    isRead: {
      type: Number,
      default: 0,
    },
    // showToday:{
    //   type: Boolean,
    //   default:false
    // },
  },
};
</script>



// WEBPACK FOOTER //
// ./src/views/details/components/detailsMatchSummary.vue